import React from 'react';
import CustomerProfileComponent from '../components/CustomerProfileComponent';

/**
 * CustomerProfile Page Wrapper
 * This page component wraps the CustomerProfileComponent for use as a standalone route.
 * The component itself can also be used directly in other contexts (e.g., details pane).
 */
const CustomerProfile: React.FC = () => {
  return <CustomerProfileComponent />;
};

export default CustomerProfile;
